module.exports = __webpack_public_path__ + "img/Roll the Dice.382b8514.jpg";